import { render, staticRenderFns } from "./FacultySpec.vue?vue&type=template&id=6356b608&scoped=true&"
import script from "./FacultySpec.vue?vue&type=script&lang=js&"
export * from "./FacultySpec.vue?vue&type=script&lang=js&"
import style0 from "./FacultySpec.vue?vue&type=style&index=0&id=6356b608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356b608",
  null
  
)

export default component.exports